import * as React from "react";
import { memo } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCrMark = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M20.267 12v8.267H12A8.267 8.267 0 1 1 20.267 12M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10v10H12C6.477 22 2 17.523 2 12m3.975.396c0 2.063 1.386 3.802 3.604 3.802 1.824 0 3.053-1.201 3.35-2.77h-1.795c-.226.72-.806 1.159-1.555 1.159-1.116 0-1.851-.877-1.851-2.191s.735-2.19 1.851-2.19c.721 0 1.287.41 1.527 1.088h1.809c-.325-1.527-1.54-2.7-3.336-2.7-2.218 0-3.604 1.739-3.604 3.802m9.365-3.604h-1.696V16h1.767v-3.76c0-.706.197-1.172.537-1.455.296-.269.692-.41 1.328-.41h.452V8.707h-.438c-.933 0-1.554.34-1.95.862z",
		clipRule: "evenodd"
	})
});
const Memo = memo(SvgCrMark);
export default Memo;
